import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';

import { RouterLink } from '@angular/router';

import { EventCardSliderComponent } from 'src/app/events/components/event-card-slider/event-card-slider.component';
@Component({
  selector: 'app-content-block-agenda',
  templateUrl: './content-block-agenda.component.html',
  styleUrls: ['./content-block-agenda.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, EventCardSliderComponent],
})
export class ContentBlockAgendaComponent extends ContentBlockBaseComponent {
  headerType = input<string>();
}
